var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-33.0981 -55.17375 286.8502 331.0425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.868 104.868H0V0h104.868z",
    fill: "#f35325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M220.654 104.868H115.787V0h104.867z",
    fill: "#81bc06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.865 220.695H0V115.828h104.865z",
    fill: "#05a6f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.654 220.695H115.787V115.828h104.867z",
    fill: "#ffba08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftStoreLogo);
export default __webpack_public_path__ + "static/media/Microsoft_Store-Logo.4635f51d75ff89a62410adaa931897db.svg";
export { ForwardRef as ReactComponent };